export default "__VITE_ASSET__DPM68fd2__"